/**
 * The locale to hand to `Intl` / `toLocale*` for the app's language (SL-1901).
 *
 * i18next resolves a bare language ('es', 'pt', 'en'), and a bare 'es' makes
 * `Intl` format the Spain way — "1.234.568,5", and no separator at all for
 * "1234". Silia's Spanish market is Mexico ("1,234,568.5"), so figures are
 * formatted through this map instead of the bare language.
 */
const INTL_LOCALE_BY_LANGUAGE: Readonly<Record<string, string>> = {
  es: 'es-MX',
  pt: 'pt-BR',
  en: 'en-US',
};

/**
 * Region-qualified locale for `language`. An unknown but valid tag passes through;
 * a malformed one ('es_MX' is normalised, 'C' is dropped) or a missing one returns
 * `undefined`, so `Intl` falls back to the browser instead of throwing a RangeError
 * in the middle of a render.
 */
export function intlLocale(language: string | undefined): string | undefined {
  if (!language) return undefined;
  const tag = language.replace(/_/g, '-');
  const mapped = INTL_LOCALE_BY_LANGUAGE[tag.split('-')[0].toLowerCase()];
  if (mapped) return mapped;
  try {
    return Intl.getCanonicalLocales(tag)[0];
  } catch {
    return undefined;
  }
}
